import React from 'react'
import './Footer.css'
function Footer() {
  return (
    <div className='footer'>
           <p>©️ 2022 Airbnb clone! no rights reserved-this is a demo</p>
           <p>Privacy  .  Terms  .  Sitemap  .  Company Details</p>
    </div>
  )
}

export default Footer